import { device } from '@utils/breakpoints'
import { useEffect, useState } from 'react'

type Keys = keyof typeof device

export const useMatchMedia = (query: Keys | string) => {
  const queryToMatch = typeof query === 'string' ? query : device[query]
  const [matches, setMatches] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const media = window.matchMedia(queryToMatch)
    setMatches(media.matches)

    const listener = () => {
      setMatches(media.matches)
    }

    if (media.addEventListener) {
      media.addEventListener('change', listener)
    } else media.addListener(listener)

    return () =>
      media.removeEventListener
        ? media.removeEventListener('change', listener)
        : media.removeListener(listener)
  }, [queryToMatch])

  return matches
}
